import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle2Icon } from "lucide-react";
import { activityPopups } from "./data";

/** Discreet, elegant social-activity toasts every ~12s. */
export function ActivityPopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout> | undefined;
    const cycle = () => {
      setVisible(true);
      hideTimer = setTimeout(() => {
        setVisible(false);
        setIndex(i => (i + 1) % activityPopups.length);
      }, 4500);
    };
    const interval = window.setInterval(cycle, 15000);
    return () => {
      if (hideTimer) clearTimeout(hideTimer);
      window.clearInterval(interval);
    };
  }, []);
  return <div className="pointer-events-none fixed bottom-[max(1rem,env(safe-area-inset-bottom))] left-1/2 z-40 w-[calc(100%-2rem)] max-w-[300px] -translate-x-1/2 sm:bottom-6 sm:left-6 sm:w-auto sm:max-w-[260px] sm:translate-x-0" data-id="element-23" data-mp="1ypvsl1n8tgo9">
      <AnimatePresence data-id="element-24" data-mp="2xqp9bnux7d77">
        {visible && <motion.div initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        type: "spring",
        stiffness: 300,
        damping: 26
      }} className="flex w-full items-center gap-2.5 rounded-2xl border border-[#e6eef5] bg-white/95 px-3.5 py-3 shadow-[0_16px_40px_-16px_rgba(31,51,69,0.35)] backdrop-blur" data-id="element-25" data-mp="2tmrcjjt2iehb">
            <span className="flex h-8 w-8 flex-none items-center justify-center rounded-full bg-[var(--calm-green)] text-[var(--accent-green)]" data-id="element-26" data-mp="2a14spbm8os13">
              <CheckCircle2Icon className="h-4 w-4" aria-hidden data-id="element-27" data-mp="20z3x0j6nme1j" />
            </span>
            <div data-id="element-28" data-mp="45sdwmthyjkn">
              <p className="text-xs font-semibold leading-snug text-[var(--ink)]" data-id="element-29" data-mp="46bqrp4aihrt">
                {activityPopups[index]}
              </p>
              <p className="mt-0.5 text-[10px] text-[var(--muted)]" data-id="element-30" data-mp="3vaa935vpx451">
                Verificado hace instantes
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}